import React from "react";
import { useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import { setCssVariables } from "../Scripts";
import "../../styles/custom-global.css";
import "../../styles/allStyles.css";
import "../../styles/fontStyles.less";

const ThemeProvider = ({ children }) => {
   const { authUser } = useSelector(({ auth }) => auth);
   useLayoutEffect(() => {
      setCssVariables();
   }, [authUser]);
   return <>{children}</>;
};

export default ThemeProvider;
